var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.822,
    height: 29.742,
    viewBox: "0 0 29.822 29.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.911 14.871)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.911 -14.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.46,4.286A15.167,15.167,0,0,0,12.282.209,4.77,4.77,0,0,0,8.266,4.942l0,3.219-3.336,0h0A4.769,4.769,0,0,0,.2,12.182a15.241,15.241,0,0,0,4.166,13.2A14.916,14.916,0,0,0,25.46,4.286ZM22.553,22.473a10.815,10.815,0,0,1-15.279,0,11.111,11.111,0,0,1-3.016-9.631.682.682,0,0,1,.673-.573h0l3.318,0c-.008.98-.018,1.98-.018,2.2a6.977,6.977,0,0,0,2.1,5.251,6.75,6.75,0,0,0,8.971.168,6.636,6.636,0,0,0,2.3-4.824c0-.133,0-.265,0-.4a.358.358,0,0,0-.357-.349h-3.4a.355.355,0,0,0-.355.375q.006.114,0,.23a2.568,2.568,0,0,1-.893,1.866,2.6,2.6,0,0,1-3.457-.065,2.921,2.921,0,0,1-.8-2.255c0-.2.008-1.166.018-2.2l1.15,0,1.044,0h6.107a.277.277,0,0,0,.249-.4A6.68,6.68,0,0,0,19.648,10.1a7.008,7.008,0,0,0-5.093-1.947l-2.176,0,0-3.217a.677.677,0,0,1,.567-.674,11.045,11.045,0,0,1,9.609,2.929,10.814,10.814,0,0,1,0,15.279Z",
    transform: "translate(0 0)",
    fill: "#dbe247"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtLogoShort);
export default __webpack_public_path__ + "static/media/ot_logo_short.e88b031c916815e58dab34eda0cb5530.svg";
export { ForwardRef as ReactComponent };